import i18n from './i18nHelpers'
import store from '../store/store'

export default {
  getOrderAdditionalHoursStatus (orderAdditionalHours) {
    let strStatus = null
    let textStatusColor = 'text-orange'
    if (orderAdditionalHours.has_payment_failure) {
      textStatusColor = '-status-alert'
      strStatus = i18n.t('message.my_reservations.payment_failed')
      if (orderAdditionalHours.cancel > 0) {
        strStatus = i18n.t('message.my_reservations.request_canceled')
      }
    } else {
      textStatusColor = 'text-orange'
      if (orderAdditionalHours.paid_status === 1 && !orderAdditionalHours.cancel) {
        strStatus = (orderAdditionalHours.status === 0) ? i18n.t('message.my_reservations.request_pending_professional') : i18n.t('message.my_reservations.request_confirmed')
        if (orderAdditionalHours.status === 1) {
          textStatusColor = '-status-accepted'
        }
      } else if (orderAdditionalHours.paid_status === 0 && !orderAdditionalHours.cancel) {
        strStatus = (!orderAdditionalHours.payment_method) ? i18n.t('message.my_reservations.provider_request_additional_hours') : i18n.t('message.my_reservations.request_pending_payment')
      } else if (orderAdditionalHours.cancel) {
        strStatus = (orderAdditionalHours.is_declined) ? i18n.t('message.my_reservations.request_declined') : i18n.t('message.my_reservations.request_canceled')
        textStatusColor = '-status-alert'
      }
    }
    return { status: strStatus, textColor: textStatusColor }
  },
  repeatBooking (order) {
    // Set pre-booking data
    let workHour = Number(order.work_hour)
    if (order.extra) {
      workHour -= Number(order.extra.work_hour)
    }
    const preBookingData = {
      is_repeat_booking: true,
      is_no_datetime_booking: 0,
      cleaning_date: null,
      cleaning_time: null,
      service_id: order.service_id,
      province_id: order.province_id,
      place_size_id: order.place_size_id,
      work_hour: workHour,
      init_work_hour: workHour
    }
    // Check user place
    if (order.user_place) {
      preBookingData.user_place_id = order.user_place.id
    }
    // Check extra
    if (order.extra) {
      preBookingData.extra = order.extra
    }
    // Check service items
    if (order.order_service_items) {
      const serviceItems = []
      let index = 0
      for (const data of order.order_service_items) {
        serviceItems[index] = data.service_item
        serviceItems[index].count = data.quantity
        index += 1
      }
      preBookingData.service_items = serviceItems
    }
    const costData = { totalPrice: 0.0 }
    store.commit('booking/SET_BOOKING_COST', costData)
    store.commit('booking/SET_PRE_BOOKING_DATA', preBookingData)
    store.commit('extras/SET_APPLIED_EXTRAS', null)
    store.commit('booking/SET_TMP_BOOKING_DATA', null)
    store.commit('booking/SET_TMP_PRE_CHECKOUT_DATA', null)
    store.commit('booking/SET_SELECTED_PROFESSIONAL', null)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/orderHelpers.js